/**
 * Elasticsearch refuses any search where skip + take exceeds the index setting
 * index.max_result_window. Our indexes use the Elasticsearch default of 10.000, and the server
 * clamps requests to it, so results beyond this position simply cannot be paged to.
 *
 * Keep in sync with ElasticSearchRequestBuilder.MaxResultWindow.
 */
export const maxSearchResultWindow = 10000;

/**
 * The highest page number that holds results for a given page size.
 */
export function getMaxPageNumber(pageSize: number): number {
  if (!pageSize || pageSize < 1) {
    return 1;
  }

  return Math.max(1, Math.floor(maxSearchResultWindow / pageSize));
}
